var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { uniqBy } from 'lodash';



import { Translate } from "../../I18N";
import { deleteSelection } from "../actions/metadataExtractionActions";






const checkPropertySelections = (property, selections) =>
selections === null || selections === void 0 ? void 0 : selections.filter((selection) => {
  if (selection.deleteSelection) {
    return false;
  }
  return (
    property === 'title' && selection.name === 'title' || selection.propertyID === property);

});

const mapStateToProps = (state) => {
  const entityDocument = state.documentViewer.doc.get('defaultDoc');
  const newSelections = state.documentViewer.metadataExtraction.get('selections');
  return {
    entityDocument,
    newSelections
  };
};

const mapDispatchToProps = (dispatch) =>
bindActionCreators(
  {
    deleteSelectionAction: deleteSelection
  },
  dispatch
);

const mergeProps = (
stateProps,



dispatchProps,


ownProps) => (
{
  onClickFunction: () =>
  dispatchProps.deleteSelectionAction(
    stateProps.entityDocument,
    ownProps.propertyName,
    ownProps.propertyID
  ),
  ownProps,
  stateProps
});

const connector = connect(mapStateToProps, mapDispatchToProps, mergeProps);



const DeleteSelectionButtonComponent = ({ onClickFunction, ownProps, stateProps }) => {var _stateProps$newSelect, _stateProps$entityDoc, _stateProps$entityDoc2;
  const property = ownProps.propertyName === 'title' ? 'title' : ownProps.propertyID;

  const selections = uniqBy(
    [
    ...(((_stateProps$newSelect = stateProps.newSelections) === null || _stateProps$newSelect === void 0 ? void 0 : _stateProps$newSelect.toJS()) || []),
    ...(((_stateProps$entityDoc = stateProps.entityDocument) === null || _stateProps$entityDoc === void 0 ? void 0 : (_stateProps$entityDoc2 = _stateProps$entityDoc.get('extractedMetadata')) === null || _stateProps$entityDoc2 === void 0 ? void 0 : _stateProps$entityDoc2.toJS()) || [])],

    'propertyID'
  );

  const hasSelections = property ? checkPropertySelections(property, selections) : false;

  if (!hasSelections || !hasSelections.length) {
    return null;
  }

  return (/*#__PURE__*/
    _jsx("button", { type: "button", className: "delete-selection", onClick: onClickFunction }, void 0, /*#__PURE__*/
    _jsx(Translate, { translationKey: "Clear PDF selection" }, void 0, "Clear PDF selection")
    ));

};

const container = connector(DeleteSelectionButtonComponent);

export { container as DeleteSelectionButton };